import { MessageCircle, Phone, Mail } from "lucide-react";
import { trackContact } from "../../lib/metaPixel";

export default function ContactRail({ settings }) {
  const s = settings || {};
  const wa = s.whatsapp || "https://wa.me/919322106632";
  const tel = `tel:${s.phone_raw || "+919322106632"}`;
  const mail = `mailto:${s.email || "admallindiagroup@gmail.com"}`;

  return (
    <>
      {/* Desktop vertical rail */}
      <div
        data-testid="contact-rail"
        className="fixed right-4 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-2 rounded-2xl border border-black/5 bg-white/90 p-2 shadow-xl backdrop-blur-md lg:flex"
      >
        <RailItem
          href={wa}
          testId="rail-whatsapp"
          label="WhatsApp"
          bg="bg-emerald-500 hover:bg-emerald-600"
          onClick={() => trackContact("whatsapp", { location: "contact_rail", label: "WhatsApp" })}
        >
          <MessageCircle size={20} />
        </RailItem>
        <RailItem
          href={tel}
          testId="rail-call"
          label="Call Us"
          bg="bg-[#FF5722] hover:bg-[#E64A19]"
          onClick={() => trackContact("phone", { location: "contact_rail", label: "Call Us" })}
        >
          <Phone size={20} />
        </RailItem>
        <RailItem
          href={mail}
          testId="rail-email"
          label="Email Us"
          bg="bg-navy hover:bg-navy-light"
          onClick={() => trackContact("email", { location: "contact_rail", label: "Email Us" })}
        >
          <Mail size={20} />
        </RailItem>
      </div>

      {/* Mobile fixed bottom bar */}
      <div
        data-testid="mobile-bottom-bar"
        className="fixed bottom-0 left-0 right-0 z-40 flex gap-2 border-t border-white/10 bg-navy p-2.5 lg:hidden"
      >
        <a
          href={tel}
          data-testid="mobile-call-btn"
          onClick={() => trackContact("phone", { location: "mobile_bottom_bar", label: "Call ADMALL" })}
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-[#FF5722] py-3 font-display text-sm font-bold uppercase tracking-wider text-white"
        >
          <Phone size={17} /> Call ADMALL
        </a>
        <a
          href={wa}
          data-testid="mobile-whatsapp-btn"
          onClick={() => trackContact("whatsapp", { location: "mobile_bottom_bar", label: "WhatsApp" })}
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-emerald-500 py-3 font-display text-sm font-bold uppercase tracking-wider text-white"
        >
          <MessageCircle size={17} /> WhatsApp
        </a>
      </div>
    </>
  );
}

function RailItem({ href, label, bg, children, testId, onClick }) {
  const external = href.startsWith("http");
  return (
    <a
      href={href}
      data-testid={testId}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      onClick={onClick}
      className="group flex flex-col items-center gap-1"
      aria-label={label}
    >
      <span className={`flex h-11 w-11 items-center justify-center rounded-xl text-white transition-all group-hover:scale-105 ${bg}`}>
        {children}
      </span>
      <span className="font-body text-[9px] font-semibold uppercase tracking-wider text-navy/60">{label}</span>
    </a>
  );
}
